import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { withTranslation } from "react-i18next";
import { Form, Button, Typography, Modal, message } from 'antd';

import ExecuteRequest from 'components/adapter/unified/ExecuteRequest';
import ExecuteResponse from 'components/adapter/unified/ExecuteResponse';

import * as types from 'reducer/actionTypes';
import { isEmpty } from 'script/common';
import { setFormFieldValue } from 'script/uniAdapter';

const AdapterPut = ({ t, webofficeURLParam, adapterName, tabName }) => {
	const interfaceName = "put"
	const uniData = useSelector(state => state.uniAdapter?.[interfaceName]);
	const isRequestActive = useSelector(state => state.uniAdapter?.[interfaceName]?.isRequestActive);
	const requestInit = useSelector(state => state.uniAdapter.requestInit);
	/** ========================================================================================================================================== **/
	const dispatch = useDispatch();
	const fetchSetUniAdapterInterface = (value) => {
		dispatch({type: types.FETCH_SET_UNIADAPTER_INTERFACE_REQUEST, interfaceType: interfaceName, value:value})
	};
	/** ========================================================================================================================================== **/
	const [ form ] = Form.useForm(); 
	const { Title } = Typography;
	const isSettingForm = uniData.response.status || !uniData.isRequestActive;

	const handleSave = () => {
		if (isRequestActive === false) {
			Modal.confirm({
				title: "Are you sure you want to save without any requests?",
				onOk: () => {
					fetchSave();
				},
				onCancel: () => {
					message.info("The save has been canceled.");
				},
			});
		} else {
			fetchSave();
		}
	};

	const fetchSave = () => {
		fetchSetUniAdapterInterface({
			interfaceType: interfaceName, 
			isRequestActive: isRequestActive,
			request: (isRequestActive ? uniData.request : requestInit),
			value: null,
			adapterName: adapterName
		});
	}

	return (
		<div style={{ padding: '20px', margin: 'auto' }}>
			<Title level={2}>{interfaceName.toUpperCase()}</Title>

			{/* Request */}
			<ExecuteRequest
				interfaceType = {interfaceName}
				webofficeURLParam={webofficeURLParam}
				adapterName={adapterName}
				tabName= {tabName}
			/>

			{/* Response */}
			{(uniData.response.status) && (
				<ExecuteResponse
					interfaceType = {interfaceName}
					webofficeURLParam={webofficeURLParam}
				/>
			)}

			{/* Save Setting */}
			{(isSettingForm) && (
				<Button type="primary" onClick={handleSave} style={{ marginTop:10 }}> Save </Button>
			)}

		</div>
	);
}

export default AdapterPut;